"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _promise = require("hub-http/helpers/promise");

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _modelShim = _interopRequireDefault(require("../modelShim"));

var currentUser;

var userShim = function userShim(user) {
  return Object.assign((0, _modelShim.default)(user, 'user_id'), {
    hasScope: function hasScope(scope) {
      if (!this.get('scopes')) throw new Error('User data has not been loaded yet');
      return this.get('scopes').indexOf(scope) !== -1;
    },
    hasRole: function hasRole(role) {
      if (!this.get('roles')) {
        throw new Error('User data has not been loaded yet');
      }

      return this.get('roles').indexOf(role) !== -1;
    },
    hasHostAccess: function hasHostAccess() {
      return this.hasRole('host') || this.hasScope('super-user');
    }
  });
};

var User = {
  get: function get() {
    return currentUser;
  },
  then: function then() {
    var _Promise$resolve, _userInfo$then;

    if (currentUser) return (_Promise$resolve = _promise.Promise.resolve(currentUser)).then.apply(_Promise$resolve, arguments);
    return (_userInfo$then = (0, _userInfo.default)().then(function (_ref) {
      var user = _ref.user;
      currentUser = userShim(user);
      return currentUser;
    })).then.apply(_userInfo$then, arguments);
  }
};
var _default = User;
exports.default = _default;
module.exports = exports.default;